import * as React from 'react'
import Link from 'next/link'
import { cn } from '@/utilities/ui'
import { NavCornerIcon } from '@/components/icons/NavCornerIcon'
import { Button } from '../../../components/ui/Button'

const classes = cn([
  'font-button font-weight-button leading-button tracking-button',
  'inline-flex items-center justify-center whitespace-nowrap gap-2',
  'transition-colors focus-visible:outline-hidden',
  'disabled:pointer-events-none disabled:opacity-50',
  // 'focus:ring-2 focus:ring-border/20',
  'text-button h-12 px-6 py-2',
  'text-olive-2 items-center justify-center hover:bg-rock-2',
  'active:bg-rock-2',
  'data-[state=open]:bg-rock-2',
])

export const NavLink: React.FC<
  React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    ref?: React.Ref<HTMLAnchorElement>
    href: string
    active?: boolean
  }
> = ({ className, ref, children, active, href, ...props }) => {
  return (
    <Link
      className={cn(classes, className, 'text-sm xl:text-button', active && 'bg-rock-1')}
      ref={ref}
      {...props}
      href={href || ''}
    >
      {children}
    </Link>
  )
}

export const NavButton: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    ref?: React.Ref<HTMLButtonElement>
    active?: boolean
  }
> = ({ className, ref, children, active, ...props }) => {
  return (
    <Button
      variant="ghost"
      className={cn(classes, 'group', active && 'bg-rock-1', 'text-sm xl:text-button', className)}
      ref={ref}
      {...props}
    >
      {children}
      <NavCornerIcon className="relative -top-1 right-0 size-2 transition duration-300 group-data-[state=open]:rotate-180" />
    </Button>
  )
}
